<template>
	<div>
		<button v-if="canOpen()" @click="open()" class="btn btn-default">
			<i class="fa fa-clock-o" aria-hidden="true"></i>
			<span v-if="timer">
				<span v-if="timer.time_spent">
					{{ timer.time_spent | humanizeSeconds }}
				</span>
			</span>
		</button>
		<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							Timer
							<span v-if="task">
								 - Tarea {{ $platform.setting.number_symbol }}{{ task.id }}
							</span>
							<span v-if="schedule">
								<span v-if="schedule.task">
									 - Tarea {{ $platform.setting.number_symbol }}{{ schedule.task.id }}
								</span>
							</span>
							<span v-if="schedule">
								<span v-if="schedule.done">
									<label class="label label-success">Hecho</label>
								</span>
							</span>
						</h4>
					</div>
					<div class="modal-body">

						<div class="row">
							<div class="col-md-12">
								<div class="alert alert-info">
									Solo el personal reponsable puede iniciar el temporizador
								</div>
							</div>
						</div>


						<div v-if="timer" class="row">
							<div class="col-md-12">
								<h3 v-if="task">
									{{ timer.author.email }}
									<span v-if="timer.time_spent">
										- {{ timer.time_spent | humanizeSeconds }}
									</span>
									<label v-if="timer.done" class="label label-success">
										Terminado
									</label>
									<label v-else class="label label-default">
										No terminado
									</label>
								</h3>
								<div v-if="timer.logs">
									<div v-if="timer.logs.length">
										<table style="width: 100%" class="table table-hover table-striped table-condensed">
											<thead>
												<tr>
													<th>Inicio</th>
													<th>Fin</th>
													<th>Total</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="log in timer.logs">
													<td>
														<span v-if="log.start">
															{{ log.start | moment }}
														</span>
													</td>
													<td>
														<span v-if="log.end">
															{{ log.end | moment }}
														</span>
													</td>
													<td>
														<span v-if="log.time_spent">
															{{ log.time_spent | humanizeSeconds }}
														</span>
													</td>
													<td>
														<div class="btn-toolbar pull-right" role="toolbar">
															<div class="btn-group" role="group" aria-label="...">
																<button
																	v-if="canStopLog(log)"
																	:ref="'buttonend-' + log.id"
																	@click="endLog(log)"
																	type="button"
																	class="btn btn-danger">
																	<i class="fa fa-stop" aria-hidden="true"></i>
																</button>
															</div>
														</div>
													</td>
												</tr>

												<tr v-if="!canStartLogTask() && userTask.id == user.id">
													<td>
													</td>
													<td>
													</td>
													<td>
													</td>
													<td>
														<div class="btn-toolbar pull-right" role="toolbar">
															<div class="btn-group" role="group" aria-label="...">
																<button
																	ref="btnStoreLog"
																	@click="storeLog()"
																	type="button"
																	class="btn btn-success">
																	<i class="fa fa-play" aria-hidden="true"></i>
																</button>
															</div>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div v-else>
										<table v-if="belongsToSchedule()" style="width: 100%" class="table table-hover table-striped table-condensed">
											<thead>
												<tr>
													<th>Inicio</th>
													<th>Fin</th>
													<th>Total</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>
													</td>
													<td>
													</td>
													<td>
													</td>
													<td>
														<div class="btn-toolbar pull-right" role="toolbar">
															<div class="btn-group" role="group" aria-label="...">
																<button
																	:disabled="!canStartLogSchedule"
																	ref="btnStoreLog"
																	@click="storeLog()"
																	type="button"
																	class="btn btn-success">
																	<i class="fa fa-play" aria-hidden="true"></i>
																</button>
															</div>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<span v-if="userTask">
								<table v-if="userTask.id == user.id" style="width: 100%" class="table table-hover table-striped table-condensed">
									<thead>
										<tr>
											<th>Inicio</th>
											<th>Fin</th>
											<th>Total</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
											</td>
											<td>
											</td>
											<td>
											</td>
											<td>
												<div class="btn-toolbar pull-right" role="toolbar">
													<div class="btn-group" role="group" aria-label="...">
														<button
															ref="btnStoreTimer"
															@click="storeTimer()"
															type="button"
															class="btn btn-success">
															<i class="fa fa-play" aria-hidden="true"></i>
														</button>
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</span>
						</div>

					</div>
					<div class="modal-footer">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
						</div>
						<div v-if="timer && timer.task" class="btn-group" role="group" aria-label="...">
							<button @click="done()" v-if="!timer.done" ref="btnDone" class="btn btn-default" title="Finalizar">
								Terminar {{ timer.time_spent | humanizeSeconds }}
							</button>
						</div>
						<div v-if="timer && timer.schedule" class="btn-group" role="group" aria-label="...">
							<button @click="doneSchedule()" v-if="!timer.done" ref="btnDone" class="btn btn-default" title="Finalizar">
								Terminar {{ timer.time_spent | humanizeSeconds }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Ladda from 'ladda'
import swal from 'sweetalert2'

export default {
	props: ['user', 'isAuth', 'timers', 'userTask', 'task', 'schedule'],
	components: {
	},
	data () {
		return {
			modal: {
				selector: 'timer-modal'
			},

			timer: null,

			canStartLogSchedule: false
		}
	},
	watch: {
		timers() {
			this.timer = null
			if(this.timers) {
				if(this.timers.length) {
					this.timer = this.timers[0]
				}
			}
		},
	},
	mounted() {
		this.timer = null
		if(this.timers) {
			if(this.timers.length) {
				this.timer = this.timers[0]
			}
		}

		if(this.userTask) {
			this.modal.selector = 'timer-modal-user-' + this.userTask.id
		}

		if(this.schedule) {
			this.modal.selector = 'timer-modal-schedule-' + this.schedule.id
		}
	},
	methods: {
		open() {
			var modal = $('#'+this.modal.selector)
			modal.modal('show')
			this.canStartSchedule()
		},
		close() {
			var modal = $('#'+this.modal.selector)
			modal.modal('hide')
		},
		endLog (log) {
			var button = 'buttonend-' + log.id
			var l = Ladda.create(this.$refs[button][0])
			l.start()
			if(this.schedule) {
				var api = 'admin/projects/schedules/' + this.schedule.id + '/timer/' + this.timer.id + '/log/' + log.id + '/end'
			} else if(this.task){
				var api = 'admin/projects/tasks/' + this.task.id + '/timer/' + this.timer.id + '/log/' + log.id + '/end'
			}
			this.$http.get(api)
				.then(response => {
					l.stop()
					swal(response.body.title, response.body.text, response.body.type)
					log = response.body.data
					if(this.timer.schedule) {
						this.close()
					}
					this.$emit('reload')
				}).catch(function(response) {
					console.log(response)
					l.stop()
				})
		},
		canStartLogTask() {
			var started = false

			if(this.timer) {
				if(this.timer.done) {
					started = true
				}
				if(this.timer.logs) {
					if(this.timer.logs.length) {
						for (var i = 0; i < this.timer.logs.length; i++) {
							var log = this.timer.logs[i]
							if(!log.end) {
								started = true
								break;
							}
						}
					}
				}
			}
			
			return started
		},
		canStartSchedule () {
			this.canStartLogSchedule = false

			var now = moment()
			if(this.schedule) {
				var estimated_start = this.schedule.estimated_start
			} else {
				var estimated_start = null
			}
			if(estimated_start) {
				if(!this.schedule.done) {
					this.canStartLogSchedule = now.diff(estimated_start) > 0
				}
			}
		},
		storeLog () {
			var button = this.$refs.btnStoreLog
			var l = Ladda.create(button)
			l.start()
			if(this.task) {
				var api = 'admin/projects/tasks/' + this.task.id + '/timer/' + this.timer.id + '/log'
			} else if(this.schedule) {
				var api = 'admin/projects/schedules/' + this.schedule.id + '/timer/' + this.timer.id + '/log'
			}
			this.$http.get(api)
				.then(response => {
					var log = response.body.data
					this.timer.logs.push(log)
					this.$emit('reload')
					l.stop()
					swal(response.body.title, response.body.text, response.body.type)
				}).catch(function(response) {
					console.log(response)
					l.stop()
				})
		},
		storeTimer () {
			var button = this.$refs.btnStoreTimer
			var l = Ladda.create(button)
			l.start()
			if(this.task) {
				var api = 'admin/projects/tasks/' + this.task.id + '/timer/log'
			} else if(this.schedule) {
				var api = 'admin/projects/schedules/' + this.schedule.id + '/timer/' + this.timer.id + '/log'
			}
			this.$http.get(api)
				.then(response => {
					swal(response.body.title, response.body.text, response.body.type)
					this.$emit('reload')
					l.stop()
				}).catch(function(response) {
					console.log(response)
					l.stop()
				})
		},
		done () {
			var button = this.$refs.btnDone
			var l = Ladda.create(button)
			l.start()
			if(this.timer.task) {
				var api = 'admin/projects/tasks/' + this.timer.task.id + '/timer/' + this.timer.id + '/done'
				this.$http.get(api)
					.then(response => {
						this.timer = response.body.data
						this.$emit('reload')
						l.stop()
						swal(response.body.title, response.body.text, response.body.type)
					}).catch(function(response) {
						console.log(response)
						l.stop()
					})
			}
		},
		belongsToSchedule() {
			var that = this

			var that = this

			if(this.user.hasRole('admin')) {
				return true
			} else {
				if(this.user.hasRole('manager')) {
					if(this.schedule) {
						if(this.schedule.users) {
							if(this.schedule.users.length) {
								var found = this.schedule.users.find(function(user) {
									return user.id == that.user.id
								});

								if(found) {
									return true
								}
							}
						}
					}
				} else {
					if(this.schedule) {
						if(this.schedule.users) {
							if(this.schedule.users.length) {
								var found = this.schedule.users.find(function(user) {
									return user.id == that.user.id
								});

								return true
							}
						}
					}
				}
			}

			return false
		},
		canOpen() {
			var can = false
			var that = this

			if(!this.user.hasRole('admin')) {
				if(!this.user.hasRole('manager')) {
					if(this.userTask) {
						if(this.userTask.id == this.user.id) {
							return true
						}
					}

					if(this.user.hasRole('staff')) {
						if(this.schedule) {
							if(this.schedule.users) {
								if(this.schedule.users.length) {
									var found = this.schedule.users.find(function(user) {
										return user.id == that.user.id;
									});

									if(found) {
										return true
									}
								}
							}
						}

						if(this.userTask) {
							return this.userTask.id == this.user.id
						}
					}

					if(this.user.hasRole('external_manager')) {
						if(this.schedule) {
							if(this.schedule.users) {
								if(this.schedule.users.length) {
									var found = this.schedule.users.find(function(user) {
										return user.id == that.user.id;
									});

									if(found) {
										return true
									}
								}
							}
						}

						if(this.userTask) {
							return this.userTask.id == this.user.id
						}
					}
				} else {
					if(this.task) {
						if(this.task.projects) {
							if(this.task.projects.length) {
								var found = this.task.projects.find(function(project) {
									return project.user_id == that.user.id;
								});

								if(found) {
									return true
								}
							}
						}
					}
					if(this.schedule) {
						if(this.schedule.users) {
							if(this.schedule.users.length) {
								var found = this.schedule.users.find(function(user) {
									return user.id == that.user.id;
								});

								if(found) {
									return true
								}
							}
						}

						if(this.schedule.task) {
							if(this.schedule.task.projects) {
								if(this.schedule.task.projects.length) {
									var found = this.schedule.task.projects.find(function(project) {
										return project.user_id == that.user.id;
									});

									if(found) {
										return true
									}
								}
							}
						}
					}

					if(this.userTask) {
						return this.userTask.id == this.user.id
					}
				}
			} else {
				return true
			}

			return can
		},
		canStopLog(log) {
			var that = this

			if(log.end) {
				return false
			}

			if(this.user.hasRole('admin')) {
				if(log.start && !log.end) {
					return true
				}
			} else {
				if(this.user.hasRole('manager')) {
					if(this.task) {
						if(this.task.projects) {
							if(this.task.projects.length) {
								var found = this.task.projects.find(function(project) {
									return project.user_id == that.user.id;
								});

								if(found) {
									if(log.start && !log.end) {
										return true
									}
								}
							}
						}

						if(this.userTask) {
							return this.userTask.id == this.user.id
						}
					}

					if(this.schedule) {
						if(this.schedule.task) {
							if(this.schedule.task.projects) {
								if(this.schedule.task.projects.length) {
									var found = this.schedule.task.projects.find(function(project) {
										return project.user_id == that.user.id;
									});

									if(found) {
										if(log.start && !log.end) {
											return true
										}
									}
								}
							}
						}
					}

					if(this.schedule) {
						if(this.schedule.users) {
							if(this.schedule.users.length) {
								var found = this.schedule.users.find(function(user) {
									return user.id == that.user.id;
								});

								if(found) {
									return true
								}
							}
						}
					}
				} else {
					if(this.schedule) {
						if(this.schedule.users) {
							if(this.schedule.users.length) {
								var found = this.schedule.users.find(function(user) {
									return user.id == that.user.id;
								});

								if(found) {
									return true
								}
							}
						}
					}

					if(this.userTask) {
						return this.userTask.id == this.user.id
					}
				}
			}

			return false
		}
		//--
	}
}
</script>


// WEBPACK FOOTER //
// src/components/projects/timers/views/Index.vue